import { Row, Col, Form } from "react-bootstrap";
import Select from "react-select";
import { useSharedSafariContext } from "provider/ShareSafariProvider";
import { useMasterContext } from "provider/MasterProvider";

const StepForm2 = () => {
    const {
        organizeSafari,
        organizeSafariErrors,
        sharedSafariDispatch,
    } = useSharedSafariContext();
    const { safariAgenda, safariCategory } = useMasterContext();

    const updateField = (name, value) => {
        sharedSafariDispatch({
            type: "UPDATE_ORGANIZE_SHARE_SAFARI",
            payload: { [name]: value },
        });
        sharedSafariDispatch({
            type: "SET_ERRORS_ORGANIZE_SHARE_SAFARI",
            payload: { [name]: "" },
        });
    };

    const generateShareSeatOptions = () => {
        const total = parseInt(organizeSafari?.total_seat);
        if (isNaN(total) || total <= 0) return [];
        return Array.from({ length: total - 1 }, (_, i) => i + 1);
    };

    const validateEstimatePrice = (field, minValue, maxValue) => {
        const errors = {};

        if (field === "estimate_price_min") {
            if (!minValue || minValue <= 0) {
                errors.estimate_price_min = "Min price must be greater than 0";
            } else if (maxValue && minValue >= maxValue) {
                errors.estimate_price_min = "Min must be less than Max price";
            }
        }

        if (field === "estimate_price_max") {
            if (!maxValue || maxValue <= 0) {
                errors.estimate_price_max = "Max price must be greater than 0";
            } else if (minValue && maxValue <= minValue) {
                errors.estimate_price_max = "Max must be greater than Min price";
            }
        }

        return errors;
    };

    return (
        <Row className="pt-3">
            {/* Theme */}
            <Col xs={12} className="mb-2">
                <label className="Modal_label">
                    Theme <span className="necessary">*</span>
                </label>
                <div className="mb-3 field-sharedsafariform-share_safari_agenda_id required">
                    <Select
                        value={safariAgenda?.find((p) => p.value === organizeSafari?.share_safari_agenda_id) || null}
                        onChange={(selectedOption) =>
                            updateField("share_safari_agenda_id", selectedOption?.value || 0)
                        }
                        options={safariAgenda}
                        isSearchable
                        isClearable
                        placeholder="Select a Park"
                        components={{ IndicatorSeparator: () => null }}
                    />
                    <div
                        className={`invalid-feedback ${organizeSafariErrors?.share_safari_agenda_id ? "d-block" : ""}`}
                        style={{ minHeight: "1.25rem" }}
                    >
                        {organizeSafariErrors?.share_safari_agenda_id}
                    </div>
                </div>

            </Col>

            {/* Stay Category */}
            <Col xs={12} className="mb-2">
                <label className="Modal_label">
                    Stay Category <span className="necessary">*</span>
                </label>
                <div className="mb-3 field-sharedsafariform-stay_category_id required">
                    <Select
                        value={safariCategory?.find((p) => p.value === organizeSafari?.stay_category_id) || null}
                        onChange={(selectedOption) =>
                            updateField("stay_category_id", selectedOption?.value || 0)
                        }
                        options={safariCategory}
                        isSearchable
                        isClearable
                        placeholder="Select a Theme"
                    />
                    <div
                        className={`invalid-feedback ${organizeSafariErrors?.stay_category_id ? "d-block" : ""}`}
                        style={{ minHeight: "1.25rem" }}
                    >
                        {organizeSafariErrors?.stay_category_id}
                    </div>
                </div>

            </Col>

            {/* Price Min and Max */}
            <Col xs={12} className="mb-2">
                <Form.Label className="Modal_label">
                    Price Per Person (INR) <span className="necessary">*</span>
                </Form.Label>

                <div className="d-flex gap-3 align-items-start flex-wrap">
                    {/* Min Price */}
                    <div className="flex-grow-1">
                        <Form.Control
                            type="number"
                            min="1"
                            placeholder="Min"
                            value={organizeSafari?.estimate_price_min || ""}
                            onChange={(e) => {
                                const value = parseInt(e.target.value, 10);
                                updateField("estimate_price_min", value);
                                const errors = validateEstimatePrice(
                                    "estimate_price_min",
                                    value,
                                    organizeSafari?.estimate_price_max
                                );
                                sharedSafariDispatch({
                                    type: "SET_ERRORS_ORGANIZE_SHARE_SAFARI",
                                    payload: errors,
                                });
                            }}
                            isInvalid={!!organizeSafariErrors?.estimate_price_min}
                        />
                        <Form.Control.Feedback type="invalid" className="d-block">
                            {organizeSafariErrors?.estimate_price_min}
                        </Form.Control.Feedback>
                    </div>

                    <span className="pt-2">-</span>

                    {/* Max Price */}
                    <div className="flex-grow-1">
                        <Form.Control
                            type="number"
                            min="1"
                            placeholder="Max"
                            value={organizeSafari?.estimate_price_max || ""}
                            onChange={(e) => {
                                const value = parseInt(e.target.value, 10);
                                updateField("estimate_price_max", value);
                                const errors = validateEstimatePrice(
                                    "estimate_price_max",
                                    organizeSafari?.estimate_price_min,
                                    value
                                );
                                sharedSafariDispatch({
                                    type: "SET_ERRORS_ORGANIZE_SHARE_SAFARI",
                                    payload: errors,
                                });
                            }}
                            isInvalid={!!organizeSafariErrors?.estimate_price_max}
                        />
                        <Form.Control.Feedback type="invalid" className="d-block">
                            {organizeSafariErrors?.estimate_price_max}
                        </Form.Control.Feedback>
                    </div>
                </div>
            </Col>


            {/* Total Seats */}
            <Col xs={12} className="mb-2">
                <Form.Label className="Modal_label">
                    Total Seats <span className="necessary">*</span>
                </Form.Label>
                <Form.Control
                    type="number"
                    min='1'
                    max="6"
                    value={organizeSafari?.total_seat || ""}
                    onChange={(e) => updateField("total_seat", e.target.value)}
                    isInvalid={!!organizeSafariErrors?.total_seat}
                />
                <Form.Control.Feedback type="invalid">
                    {organizeSafariErrors?.total_seat || "Total seat is required."}
                </Form.Control.Feedback>
            </Col>

            {/* Share Seats */}
            <Col xs={12} className="mb-2">
                <Form.Label className="Modal_label">
                    Share Seats <span className="necessary">*</span>
                </Form.Label>
                <Form.Select
                    value={organizeSafari?.share_seat || ""}
                    onChange={(e) => updateField("share_seat", e.target.value)}
                    isInvalid={!!organizeSafariErrors?.share_seat}
                >
                    <option value="">Select</option>
                    {generateShareSeatOptions().map((num) => (
                        <option key={num} value={num}>{num}</option>
                    ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                    {organizeSafariErrors?.share_seat || "Please select share seats."}
                </Form.Control.Feedback>
            </Col>

        </Row>
    );
};

export default StepForm2;
